<template>
  <div>

    <v-container fluid class="white elevation-3 margen d-flex justify-space-between">
      <v-row class="d-flex  justify-space-between">
        <v-col cols="12" sm="12" md="5" class="my-auto d-flex">
          <v-btn small text class="mt-3 mx-3 grey lighten-2" to="/salidaProcesos">
            <v-icon>mdi-chevron-left</v-icon>
          </v-btn>
          <h1>Editar Resguardo</h1>
        </v-col>
        <v-col cols="12" sm="12" md="3" class="my-auto">
          <span class="mt-2 text-h4 ml-auto">
            {{ mostrarFolio }}
          </span>
        </v-col>
      </v-row>
    </v-container>

    <v-card class="mt-3 mx-1" :loading="cargando" :disabled="infoResguardo.ESTATUS == 'B' || infoResguardo.ESTATUS == 'T'" >
      <v-card-title>
        <h4>Informacion:</h4>
        <v-btn class="mt-2 ml-auto primary mx-1" small text @click="terminarMaquinado">Pieza Terminada</v-btn>
      </v-card-title>

      <v-divider ></v-divider>

        <v-text-field label="Producto" v-model="articuloProceso" readonly class="ma-auto mx-3 my-2"/>
        <!-- SECCION FECHA1 -->
        <v-menu v-model="modalFecha1" :close-on-content-click="false" :nudge-right="40" transition="scale-transition"
        offset-y min-width="auto">
        <template v-slot:activator="{ on, attrs }">
        <v-text-field v-model="fechaSalida" label="Fecha salida" prepend-icon="mdi-calendar"
        light readonly v-bind="attrs" v-on="on" class="mx-3"/>
        </template>
        <v-date-picker v-model="fechaSalida" @input="modalFecha1 = false" :min="minFecha[0]"/>
        </v-menu>
        <!-- FIN SECCION FECHA1 -->
        <v-autocomplete
          class="mx-3"
          label="Almacen"
          v-model="almacenSeleccionado"
          :items="almacenes"
          item-text="NOMBRE"
          item-value="ALMACEN_ID"
        />        
      <div class="mx-3">

        <v-row>
          <v-col cols="12" sm="12" md="12" class="">
            <v-data-table :headers="colsSalida" :items="articulos" class="tamTexto grey lighten-3 allB">
              <template v-slot:header="{props:{headers} }">
                <thead>
                  <tr>
                    <th :colspan="headers.length">
                      Pieza/s en proceso
                    </th>
                  </tr>
                </thead>
              </template>
            </v-data-table>        
          </v-col>

        </v-row>
      </div>
      <v-divider></v-divider>

      <v-card-actions class="d-flex justify-space-around" v-if="infoResguardo.ESTATUS != 'M' && infoResguardo.ESTATUS != 'T'">
        <v-btn small class="grey darken-2" dark to="/maquinado"> Cancelar</v-btn>
        <v-btn small class="primary darken-2" dark @click="guardarCambios"> Guardar Cambios</v-btn>
      </v-card-actions>
    </v-card>

  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
export default {
  data() {
    return {
      //DATOS PARA EDITAR
      resguardo_id:  0,
      fechaSalida:   '',
      fechaEntrada:  '',
      almacenSalida: null,
      almacenEntrada:null,
      articuloProceso:'',
      almacenSeleccionado:null,

      //DATOS PARA VALIDACION
      articulos:[],
      reglas:[],
      reglasFecha:[],

      cargando:     false,
      infoResguardo:null,
      estatus:'',
      minFecha:'',
      modalFecha1:  false,
      almacenes:[],
      proyectos:[],
      colsSalida:[
        {text:"Nombre", value:'NOMBRE'},
        {text:"Cantidad", value:'CANTIDAD'},
      ],
    }
  },

  // ------------------------------------------------------------------------------
  computed: {
    ...mapGetters(['getURLAPI','getUsuario','getFechaActual']),

    // ------------------------------------------------------------------------------
    mostrarFolio : function () {
      if (this.infoResguardo && this.infoResguardo.FOLIO) {
        return this.infoResguardo.FOLIO
      }
      else{
        return ''
      }
    },

    // ------------------------------------------------------------------------------
    articulosSalida:function(){
      return this.articulos.filter( (articulo) =>{
        return articulo.TIPO.toUpperCase().match("S");
      } )
    },

    // ------------------------------------------------------------------------------
    articulosEntrada:function(){
      return this.articulos.filter( (articulo) =>{
        return articulo.TIPO.toUpperCase().match("E");
      } )
    },


  },

  // ------------------------------------------------------------------------------
  methods:{
    log(){
      // console.warn(this.proyectoSeleccionado);
    },

    // ------------------------------------------------------------------------------
    getDetalle(){
      this.infoResguardo = null;
      this.estatus = '';
      this.fechaSalida = null;
      this.articulos = [];

      this.cargando = true;
      let datosForm = new FormData();
      datosForm.append("RESGUARDO_ID",this.resguardo_id )
      axios.post(`${this.getURLAPI}/SalidaProcesos/mostrarDetalle`, datosForm)
      .then( ({data}) =>{
        console.log(data);
        this.articuloProceso = data[0].NOMBREA;
        this.infoResguardo= data[0];
        this.almacenSeleccionado = data[0].ALMACEN_ID;
        this.estatus = data[0].ESTATUS;
        this.fechaSalida  = data[0].FECHA.split(' ')[0];
        this.articulos = data;
        
      })
      this.cargando = false;

    },

    // ------------------------------------------------------------------------------
    async getAlmacenes(){
      this.almacenes = (await axios.get(`${this.getURLAPI}/Show/allStorage`)).data;
      // console.log(this.almacenes);
    },

    // ------------------------------------------------------------------------------
    async getProyectos(){
      this.proyectos = (await axios.get(`${this.getURLAPI}/Show/allProyect`)).data;
      // console.log(this.almacenes);
    },
    
    // ------------------------------------------------------------------------------
    getTexto(item){
      return `${item.FOLIO} | ${item.NOMBRE}`
    },

    // ------------------------------------------------------------------------------
    // guardarCambios(){
    //   if (this.fechaSalida != '' && this.almacenSalida != null && this.proyectoSeleccionado !== null) 
    //   {  
    //     let datosForm = new FormData();
    //     datosForm.append("MAQUINADO_ID",        this.resguardo_id);
    //     datosForm.append("FECHA_SALIDA",        this.fechaSalida);
    //     datosForm.append("ALMACEN_SALIDA",      this.almacenSalida);
    //     datosForm.append("PROYECTO_ID",         this.proyectoSeleccionado);
    //     datosForm.append("USUARIO_MODIFICADOR", this.getUsuario);

    //     if(this.almacenEntrada != null){
    //       datosForm.append("ALMACEN_ENTRADA",     this.almacenEntrada);
    //     }
    //     if(this.fechaEntrada != null){
    //       datosForm.append("FECHA_ENTRADA",     this.fechaEntrada);
    //     }

    //     for (const val of datosForm.values()) {
    //       console.log(val);
    //     }

    //     axios.post(`${this.getURLAPI}/Maquinado/editarMaquinado`,datosForm)
    //     .then( ({data}) => {
    //       this.$root.vtoast.show(
    //       { message: data.MSG, color:data.STATUS=="OK" ? 'success darken-1' : "red darken-1", 
    //         timer:10000,       icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' } 
    //       )
    //       if(data.STATUS == 'OK'){
    //         this.getDetalle();
    //       }

    //     })
    //     .catch();

    //   }
    //   else{
    //     this.$root.vtoast.show({
    //       message: "Verifica los datos",
    //       color: "black",
    //       timer: 10000,
    //       icon: "mdi-alert-circle-outline",
    //     });
    //   }
    // },

    // ------------------------------------------------------------------------------
    terminarMaquinado(){
      // console.log(this.almacenEntrada);
      let confirmar = confirm(`¿Terminar maquinado ${this.mostrarFolio}?`);

      if (confirmar) {
        if (this.fechaSalida != '') {
          let datosForm = new FormData();
          datosForm.append("RESGUARDO_ID", this.resguardo_id);
          datosForm.append("USUARIO_MODIFICADOR", this.getUsuario);
          datosForm.append("FOLIO", this.infoResguardo.FOLIO);
          // datosForm.append("FECHA_ENTRADA", this.fechaSalida);
  
          // if(this.almacenSeleccionado != 0){
          //   datosForm.append("ALMACEN_ENTRADA", this.almacenSeleccionado);
          // }
          
  
          axios.post(`${this.getURLAPI}/SalidaProcesos/terminarProceso`,datosForm)
          .then( ({data}) => {
            this.$root.vtoast.show(
              { 
                message: data.MSG, 
                color:data.STATUS=="OK" ? 'success darken-2' : "red darken-1", 
                timer:10000,
                icon: data.STATUS=="OK" ? 'mdi-check':'mdi-alert-circle-outline' 
              } 
            )
            if(data.STATUS == 'ERROR_ALMACEN'){
              this.reglas = [ ()=> data.MSG ];
              // console.log(this.reglas);
            }else if(data.STATUS == 'OK') this.$router.push('/salidaProcesos')
          })
          
        } else {
          this.reglasFecha = [() => "Selecciona la fecha de entrada del producto."]
        }
      }
    },

  },

  mounted() {
    window.scrollTo(0,0);
  },
  // ------------------------------------------------------------------------------
  created() {
    this.minFecha = this.getFechaActual.split(" ");
    document.title = "Editar Salida Proceso | Bombas y Suministros del Norte";
    this.resguardo_id = this.$route.params['id'];
    this.getDetalle();
    this.getAlmacenes();
    this.getProyectos();
  },
};
</script>

<style></style>
